import type { AssignmentsOptionsResponse } from "@/api/restaurant/types";
import { RestaurantRole } from "@/store/AuthStore";

export function deriveRestaurantRole(
  assignment: AssignmentsOptionsResponse | undefined
): RestaurantRole {
  if (
    assignment?.groups?.some(
      g => g.role === RestaurantRole.GROUP || g.role !== null
    )
  ) {
    return RestaurantRole.GROUP;
  }

  if (
    assignment?.groups?.some(g =>
      g.brands?.some(b => b.role === RestaurantRole.BRAND || b.role !== null)
    )
  ) {
    return RestaurantRole.BRAND;
  }

  return RestaurantRole.BRANCH;
}
